import { BookOpen } from 'lucide-react';
import type { ViewerRole } from './types';

const MESSAGES: Record<ViewerRole, { title: string; subtitle: string }> = {
  student: {
    title: "Rien pour l'instant",
    subtitle: 'Tes devoirs, défis et résultats apparaîtront ici.',
  },
  tutor: {
    title: 'Pas encore d’activité',
    subtitle: 'Les devoirs que tu donnes, les défis et essais de tes élèves apparaîtront ici.',
  },
  parent: {
    title: 'Pas encore d’activité',
    subtitle: 'Les devoirs, défis et résultats de tes enfants apparaîtront ici.',
  },
  player: {
    title: "Rien pour l'instant",
    subtitle: 'Tes défis partagés et tes essais terminés apparaîtront ici.',
  },
};

export function EmptyFeed({ role }: { role: ViewerRole }) {
  const { title, subtitle } = MESSAGES[role];
  return (
    <div className="flex flex-col items-center gap-3 py-16 text-center">
      <div className="bg-ink-100 flex h-16 w-16 items-center justify-center rounded-full">
        <BookOpen className="text-ink-300 h-7 w-7" />
      </div>
      <p className="font-display text-ink-700 text-base font-bold">{title}</p>
      <p className="text-ink-400 max-w-[260px] font-sans text-sm">{subtitle}</p>
    </div>
  );
}
